module.exports = __webpack_public_path__ + "img/icon-add-light-gray.c4678fa4.svg";